<template>
  <input
    :id="fieldId"
    type="radio"
    :value="value"
    :checked="modelValue === value"
    v-bind="$attrs"
    @change="
      $emit('update:modelValue', ($event.target as HTMLInputElement).value)
    "
  />
  <label data-label :for="fieldId">{{ label }}</label>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'UtilityFormRadio',
  props: {
    modelValue: { type: String, required: true },
    fieldId: { type: String, required: true },
    label: { type: String, required: true },
    value: { type: String, required: true },
  },
  emits: {
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    'update:modelValue': (value: string) => true,
  },
});
</script>
